// Code generated by tools/authzmirror; DO NOT EDIT.
// The capability table of internal/authz (ZENITH.md §6.2). Regenerate with
// `make generate`; a stale copy fails generate-check in CI.
//
// The UI reads this only to decide what to render. The server is the
// authority and enforces every capability itself.
import type { components } from "./api/schema";

type Role = components["schemas"]["Role"];

/** Every capability a handler may name. */
export type Capability =
  | "ai.use"
  | "audit.read"
  | "authmethod.write"
  | "catalogue.curate"
  | "catalogue.write"
  | "config.device_apply"
  | "config.plan"
  | "customer.delete"
  | "customer.read"
  | "customer.write"
  | "device.cds_transfer.approve"
  | "device.cds_transfer.release"
  | "device.cli.read"
  | "device.command"
  | "device.console.ap"
  | "device.console.switch"
  | "device.diagnostics.read"
  | "device.poe.cycle"
  | "device.write"
  | "gateway.plan"
  | "gateway.read"
  | "gateway.write"
  | "guest.export"
  | "membership.write"
  | "network.material.reveal"
  | "network.write"
  | "org.create_root"
  | "org.delete"
  | "org.read"
  | "org.write"
  | "pan.material.reveal"
  | "pan.read"
  | "pan.write"
  | "planner.write"
  | "portal.read"
  | "portal.voucher.write"
  | "portal.write"
  | "radio.overlay.write"
  | "serviceprincipal.write"
  | "site.arpiq_lab.write"
  | "site.cds_transfer.request"
  | "site.delete"
  | "site.firmware_catalog.read"
  | "site.password.reveal"
  | "site.read"
  | "site.ssh_key.reveal"
  | "site.ssh_keys.write"
  | "site.write"
  | "user.invite"
  | "user.read"
  | "user.write";

/** Capabilities by role. A capability held by no role appears in the union
 * and in no set: `org.create_root`, the provider's own act, and
 * `device.diagnostics.read`, which the superuser flag holds and no role does
 * (ADR-0092 decision 4). Neither can be reached by granting a role. */
export const CAPABILITIES: Record<Role, ReadonlySet<Capability>> = {
  owner: new Set<Capability>([
    "ai.use",
    "audit.read",
    "authmethod.write",
    "catalogue.write",
    "config.device_apply",
    "config.plan",
    "customer.delete",
    "customer.read",
    "customer.write",
    "device.cli.read",
    "device.command",
    "device.poe.cycle",
    "device.write",
    "gateway.plan",
    "gateway.read",
    "gateway.write",
    "guest.export",
    "membership.write",
    "network.material.reveal",
    "network.write",
    "org.delete",
    "org.read",
    "org.write",
    "pan.material.reveal",
    "pan.read",
    "pan.write",
    "planner.write",
    "portal.read",
    "portal.voucher.write",
    "portal.write",
    "radio.overlay.write",
    "serviceprincipal.write",
    "site.delete",
    "site.password.reveal",
    "site.read",
    "site.write",
    "user.invite",
    "user.read",
    "user.write",
  ]),
  admin: new Set<Capability>([
    "ai.use",
    "audit.read",
    "catalogue.write",
    "config.device_apply",
    "config.plan",
    "customer.read",
    "customer.write",
    "device.cli.read",
    "device.command",
    "device.poe.cycle",
    "device.write",
    "gateway.plan",
    "gateway.read",
    "gateway.write",
    "guest.export",
    "membership.write",
    "network.material.reveal",
    "network.write",
    "org.read",
    "pan.material.reveal",
    "pan.read",
    "pan.write",
    "planner.write",
    "portal.read",
    "portal.voucher.write",
    "portal.write",
    "radio.overlay.write",
    "site.delete",
    "site.password.reveal",
    "site.read",
    "site.write",
    "user.invite",
    "user.read",
    "user.write",
  ]),
  operator: new Set<Capability>([
    "ai.use",
    "customer.read",
    "device.cli.read",
    "device.command",
    "device.poe.cycle",
    "gateway.plan",
    "gateway.read",
    "guest.export",
    "network.material.reveal",
    "org.read",
    "pan.material.reveal",
    "pan.read",
    "pan.write",
    "planner.write",
    "portal.read",
    "portal.voucher.write",
    "portal.write",
    "site.password.reveal",
    "site.read",
  ]),
  viewer: new Set<Capability>([
    "customer.read",
    "gateway.read",
    "org.read",
    "pan.read",
    "portal.read",
    "site.read",
  ]),
  guest_desk: new Set<Capability>([
    "customer.read",
    "guest.export",
    "org.read",
    "portal.read",
    "portal.voucher.write",
    "site.read",
  ]),
  unit_manager: new Set<Capability>([
    "customer.read",
    "org.read",
    "pan.material.reveal",
    "pan.read",
    "pan.write",
    "site.read",
  ]),
};
